import React, { useCallback, useEffect, useState } from 'react';
import { Box, Dialog, DialogTitle, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useHoverNavigation from './use-hover-navigation';
import { hoverHighlightSx } from './hover-style';
import { Check } from '@mui/icons-material';
import AppsActionBarWithSettings from './apps-action-bar-with-settings';

const panelSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'box-shadow 0.3s ease, filter 0.3s ease',
    borderRadius: 4,
    margin: 2
};


export default function YesNo() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [popupLabel, setPopupLabel] = useState(null);
    const [actionBarActions, setActionBarActions] = useState([]);

    const itemCount = 2 + actionBarActions.length; // Yes, No + action bar items

    const onSelect = useCallback((index) => {
        if (index === 0) setPopupLabel(t('APPLICATIONS.YES_NO.YES'));
        else if (index === 1) setPopupLabel(t('APPLICATIONS.YES_NO.NO'));
        else {
            // Action bar item clicked
            const actionIndex = index - 2;
            if (actionIndex >= 0 && actionIndex < actionBarActions.length) {
                actionBarActions[actionIndex].onClick();
            }
        }
    }, [t, actionBarActions]);

    const { active, activeIndex, paused, pause } = useHoverNavigation(itemCount, onSelect);

    // Pause scanning when popup opens
    useEffect(() => {
        if (popupLabel !== null) pause();
    }, [popupLabel, pause]);

    // Close popup when scanning resumes (Enter pressed while paused)
    useEffect(() => {
        if (!paused) setPopupLabel(null);
    }, [paused]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
            {/* Action bar */}
            <AppsActionBarWithSettings
                customActions={[]}
                helperActions={[]}
                activeIndex={activeIndex - 2}
                active={active && activeIndex >= 2}
                onActionsChange={setActionBarActions}
                flex="0 0 auto"
            />

            {/* Answer panels — 80% */}
            <Box sx={{ display: 'flex', flex: '1 1 80%', minHeight: 0 }}>
                <Box
                    sx={{
                        ...panelSx,
                        flex: 1,
                        border:"8px solid",
                        borderColor: '#4caf50',
                        color: '#4caf50',
                        ...(active && activeIndex === 0 && hoverHighlightSx),
                    }}
                >
                    <Check sx={{ fontSize: 120 }} />
                    <Typography variant="h2" sx={{ fontWeight: 700, mt: 2 }}>
                        {t('APPLICATIONS.YES_NO.YES')}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        ...panelSx,
                        flex: 1,
                        border:"8px solid",
                        borderColor: '#f44336',
                        color: '#f44336',
                        ...(active && activeIndex === 1 && hoverHighlightSx),
                    }}
                >
                    <CloseIcon sx={{ fontSize: 120 }} />
                    <Typography variant="h2" sx={{ fontWeight: 700, mt: 2 }}>
                        {t('APPLICATIONS.YES_NO.NO')}
                    </Typography>
                </Box>
            </Box>

            <Dialog open={popupLabel !== null} onClose={() => setPopupLabel(null)}>
                <DialogTitle sx={{ textAlign: 'center', px: 8, py: 4, fontSize: '2rem' }}>
                    {popupLabel}
                </DialogTitle>
            </Dialog>
        </Box>
    );
}
